import { useState } from 'react';
import GarageCard from './GarageCard';
import AddGarageModal from './AddGarageModal';
import GarageSettingsModal from './GarageSettingsModal';
import PricingModal from '../PricingModal';
import { getSubscriptionLimits, getSettings, getOwnedVehicleCount } from '../../utils/storage';

export default function GarageList({
  garages,
  vehicles,
  onSelectGarage,
  onAddGarage,
  onUpdateGarage,
  onDeleteGarage,
  onToast,
  currentUserEmail,
}) {
  const [showAdd, setShowAdd] = useState(false);
  const [showPricing, setShowPricing] = useState(false);
  const [settingsGarageId, setSettingsGarageId] = useState(null);

  const settingsGarage = settingsGarageId
    ? garages.find((g) => g.id === settingsGarageId) || null
    : null;

  function handleAdd(name, photo) {
    onAddGarage(name, photo);
    setShowAdd(false);
  }

  return (
    <div className="screen" style={{ paddingBottom: 100, overflowY: 'auto' }}>
      <div style={{ marginBottom: 24, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div>
          <h1 className="screen-title">Garages</h1>
          <p className="screen-subtitle">
            {(() => {
              const limits = getSubscriptionLimits();
              const plan = getSettings().subscription.plan;
              const ownedGarages = garages.filter(g => g.role !== 'collaborator').length;
              const maxG = limits.maxGarages === Infinity ? '∞' : limits.maxGarages;
              return `${ownedGarages}/${maxG} garages, ${getOwnedVehicleCount()} vehicles (${plan === 'free' ? 'Free' : plan.charAt(0).toUpperCase() + plan.slice(1)})`;
            })()}
          </p>
        </div>
        {(() => {
          const limits = getSubscriptionLimits();
          const ownedGarageCount = garages.filter(g => g.role !== 'collaborator').length;
          const atLimit = ownedGarageCount >= limits.maxGarages;
          return (
            <button
              onClick={() => {
                if (atLimit) { setShowPricing(true); return; }
                setShowAdd(true);
              }}
              title={atLimit ? 'Upgrade to Add More Garages' : 'Add Garage'}
              style={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                background: 'var(--accent)',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                cursor: 'pointer',
                flexShrink: 0,
                opacity: atLimit ? 0.6 : 1,
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            </button>
          );
        })()}
      </div>

      {garages.length === 0 && (
        <div
          className="card"
          style={{
            textAlign: 'center',
            padding: '40px 20px',
            color: 'var(--text-muted)',
            marginBottom: 16,
          }}
        >
          <p style={{ fontSize: '0.9375rem', marginBottom: 4 }}>No garages yet.</p>
          <p style={{ fontSize: '0.8125rem' }}>Create your first garage to get started.</p>
        </div>
      )}

      {garages.map((garage) => (
        <GarageCard
          key={garage.id}
          garage={garage}
          vehicleCount={vehicles.filter((v) => v.garageId === garage.id).length}
          onClick={() => onSelectGarage(garage.id)}
          onOpenSettings={() => setSettingsGarageId(garage.id)}
          currentUserEmail={currentUserEmail}
        />
      ))}

      {showAdd && (
        <AddGarageModal onAdd={handleAdd} onClose={() => setShowAdd(false)} />
      )}

      {showPricing && (
        <PricingModal
          onClose={() => setShowPricing(false)}
          onToast={onToast}
          title="Garage Limit Reached"
          subtitle={`Your plan supports ${getSubscriptionLimits().maxGarages} garage${getSubscriptionLimits().maxGarages === 1 ? '' : 's'}. Upgrade for more.`}
        />
      )}

      {settingsGarage && (
        <GarageSettingsModal
          garage={settingsGarage}
          vehicleCount={vehicles.filter((v) => v.garageId === settingsGarageId).length}
          onUpdate={onUpdateGarage}
          onDelete={(id) => {
            onDeleteGarage(id);
            setSettingsGarageId(null);
          }}
          onClose={() => setSettingsGarageId(null)}
          onToast={onToast}
        />
      )}
    </div>
  );
}
